module.exports = __webpack_public_path__ + "static/media/ConFps.fb24d11f.mp4";